module.exports = __webpack_public_path__ + "img/border.8bd044a.png";